import { message } from 'antd';

export function showToast(text: string): void {
  const t = text?.trim();
  if (!t) {
    return;
  }
  message.info(t);
}
